import PropTypes from "prop-types";

export const ModalDimmer = ({ children = null }) => children;

ModalDimmer.propTypes = {
  children: PropTypes.node,
};
